export default __webpack_public_path__ + "static/media/SuperToDo.c230b43a.jpg";